import RouteWrapper from "components/route-wrapper/RouteWrapper";
import Links from "routes/links-route/components/Links";
import { NonProtectedRoutes } from "types/routes";

function LinksRoute() {
	return (
		<RouteWrapper route={NonProtectedRoutes.LINKS}>
			<Links />
		</RouteWrapper>
	);
}

export default LinksRoute;
